export default __webpack_public_path__ + "static/wendy-52536aaf10019d7c6e49cea4b063652d.jpg";